import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class ServiceAreasService {

  constructor(private http: HttpClient) { }

  get(queryParams?:any): Observable<any> {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.API_URL + urls.SERVICE_AREAS, {params})
      .pipe(
        catchError(errorHandl)
      );
  }

  getPicker(queryParams?:any): Observable<any> {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.API_URL + urls.SERVICE_AREAS + urls.PICKER, {params})
      .pipe(
        catchError(errorHandl)
      );
  }

  getById(id : any): Observable<any> {
    return this.http.get<any>(urls.API_URL + urls.SERVICE_AREAS + '/'+ id)
      .pipe(
        catchError(errorHandl)
      );
  }

  save(data : any, id?:any): Observable<any>{
    if(id){
      return this.http.patch<any>(urls.API_URL + urls.SERVICE_AREAS + '/' + id ,data)
      .pipe(
        catchError(errorHandl)
      );
    }else{
      return this.http.post<any>(urls.API_URL + urls.SERVICE_AREAS ,data)
      .pipe(
        catchError(errorHandl)
      );
    }

  }
}
